import axios from "../../axios";
import {
    Grid,
    Typography,
    Stack,
} from '@mui/material';
import {styled} from "@mui/material/styles";
import * as React from "react";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    '@media (min-width: 960px)': {
        width: '700px',
    },
    width: '200px',
    height: 'auto',
    borderRadius: '5px'
});

const ImageTextCard = ({image_text}) => {

    const type = image_text.direction ;
    const {mode} = useDarkMode();
    return (
        <div>
            { type != 'IMAGE' && type != 'TEXT' ?
                <Grid component={"div"} class={"imageTextContainer"} container style={ type == 'RIGHT_PICTURE' ? {flexDirection: "row-reverse"} : {}}>
                    <Grid item xs={12} lg={7} md={7}>
                        <Stack alignItems={'center'}>
                            <Img alt={image_text.image.alternativeText} src={`${axios.defaults.apiBaseURL}/${image_text.image.uri}`} />
                        </Stack>

                    </Grid>
                    <Grid item xs sm>
                        <Stack alignItems={'center'}>
                            <Typography variant={"subtitle13"} style={{color : mode.settings.textColor6, textAlign: 'center'}}>
                                {image_text.title.text}
                            </Typography>
                            <Typography  variant={"subtitle3"} style={{color : mode.settings.textColor3, marginTop: '30px', textAlign: 'justify'}}>
                                {image_text.text.text}  test
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
                :

                type == 'TEXT' ?
                    <Grid component={"div"}>
                        <Typography variant={"subtitle13"} style={{color : mode.settings.textColor4}}>
                            {image_text.title.text}
                        </Typography>
                        <Typography style={{color : mode.settings.textColor3, marginTop: '30px'}}>
                            {image_text.text.text}
                        </Typography>
                    </Grid>
                    :
                    <Stack>
                        <Typography variant={"subtitle13"} style={{color : mode.settings.textColor4}}>
                            {image_text.title.text}
                        </Typography>
                        <Stack alignItems={'center'}>
                            <img
                                alt={image_text.image.alternativeText}
                                src={`${axios.defaults.apiBaseURL}/${image_text.image.uri}`}
                                style={{width: '90%', marginTop : '-70px'}}
                            />
                        </Stack>
                    </Stack>
            }
        </div>
    )
}

export default ImageTextCard;
